var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccountVerificationsPresentation',{attrs:{"username":_vm.maskedUsername,"error-code":_vm.errorCode},on:{"confirmSignup":_vm.handleConfirmSignup,"resendSignup":_vm.handleResendSignup}})
}
var staticRenderFns = []

export { render, staticRenderFns }